// src/lib/firestoreUser.js
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';

export async function fetchUserDoc(uid) {
  if (!uid) return null;
  const userRef = doc(db, 'users', uid);
  const snapshot = await getDoc(userRef);
  if (!snapshot.exists()) {
    return null; 
  }
  return snapshot.data();
}
